<script>
import compoment from '@/components/draggable/CustomComponents/Input/DInputPreview'
export default {
  name: 'DColumnNamePreview',
  extends: compoment
}
</script>
